import { useState, useEffect } from "react";

export const useRecaptcha = () => {
  const [rightResponse, setRightResponse] = useState();
  const [question, setQuestion] = useState();
  const [response, setResponse] = useState();

  const isValid = () => rightResponse === response;

  const generateQuestion = () => {
    const a = Math.floor(Math.random() * 101);
    const b = Math.floor(Math.random() * 101);

    setRightResponse(Number(a + b));

    setQuestion(`Qual é o valor da soma ${a} + ${b}?`);
  };

  const reply = (value) => {
    const parsedValue = Number(value);
    setResponse(parsedValue);
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  return {
    question,
    isValid,
    reply,
    generateQuestion
  };
};
